module.exports = __webpack_public_path__ + "assets/img/sc.37497b4c.svg";